import { render, staticRenderFns } from "./cotizacionesHUB.vue?vue&type=template&id=575e1e62&scoped=true"
import script from "./cotizacionesHUB.vue?vue&type=script&lang=js"
export * from "./cotizacionesHUB.vue?vue&type=script&lang=js"
import style0 from "./cotizacionesHUB.vue?vue&type=style&index=0&id=575e1e62&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "575e1e62",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VContainer,VRow})
